import NotFoundComponent from "../components/not-found/not-found.component";




const NotFound = () => {

    return (
        <>
            <NotFoundComponent></NotFoundComponent>
        </>
    )

}

export default NotFound;